import {FOOTER, HEADER} from '../../utils/constants/public/psr.js';

export default {
  callToActionGuideLines: {
    existingUser: {
      availabilityNote: 'Lines are open between 9am and 5pm, Monday to Friday.',
      heading: 'Already taking card payments with us?',
      phoneNumber: '0800 161 5393',
    },
    heading: 'Take card payments with Lloyds Bank Cardnet',
    newUser: {
      availabilityNote: 'Lines are open between 9am and 5pm, Monday to Friday.',
      heading: 'New to Lloyds Bank Cardnet?',
      phoneNumber: '0330 134 7976',
    },
  },
  cancelDialog: {
    cancelDialog: 'Cancel Dialog',
    message: "If you cancel now, you'll lose any details you've entered",
    primaryButtonText: 'Yes, cancel',
    secondaryButtonText: 'No, carry on',
    title: 'Are you sure you want to cancel?',
  },
  cardPaymentServicesDetails: {
    backToContent: 'Back to footnote',
    callToActionGuideLines: {
      applicationJourneyLink:
        'https://businessbanking.lloydsbank.co.uk/cardnet/enquiry/taking-card-payments',
      clockText: 'Time to apply: 20 minutes (estimate)',
      criteriaList: [
        {
          description: 'you’re a Lloyds Bank or Bank of Scotland customer',
          id: 'customer-type',
        },
        {
          description:
            'you’re looking to take card payments face to face only or together with over-the-phone payments',
          id: 'payment-type',
        },
        {
          description:
            'you have an average card transaction value of under £500',
          id: 'transaction-value',
        },
        {
          description:
            'you have an estimated annual card turnover of under £300,000',
          id: 'annual-turnover',
        },
        {
          description:
            'you do not require multiple terminals, in multiple locations.',
          id: 'require-location',
        },
      ],
      ctaLabel: 'Apply now',
      ctaLabelSrText: 'To start your application',
      note: 'Please note, not all industries/sectors will be eligible for Cardnet® products.',
      titleText: 'Apply online if:',
    },
    download: 'Download quote (PDF)',
    downloadSrText: 'Download your quote',
    example: {
      feeSubText: 'authorisation fee',
      labelText: 'Example',
      row1: 'If your customer uses a Mastercard <b>personal debit card in person</b> to purchase a £10 item, you would pay:',
      row2: 'If your customer uses a VISA <b>personal credit card online or by phone</b> to purchase a £10 item, you would pay:',
    },
    fileNameExtension: '.pdf',
    fileNamePrefix: 'CQ-',
    footnotes: [
      {
        description:
          'The proportion of your transactions represented by each card type.',
        id: 'transactionproportion',
        refid: 'transactionproportion-ref',
      },
      {
        description: 'Personal debit cards.',
        id: 'personaldebitcard',
        refid: 'personaldebitcard-ref',
      },
      {
        description: 'Personal credit cards.',
        id: 'personalcreditcard',
        refid: 'personalcreditcard-ref',
      },
      {
        description: 'Business debit cards.',
        id: 'businessdebitcard',
        refid: 'businessdebitcard-ref',
      },
      {
        description:
          "These are the most commonly used cards for most merchants. If your Mastercard and VISA rates are in percent (%), you pay us a percentage of each card payment you receive. This varies depending on the type of card. If your Mastercard and VISA rates are in pence (p), you pay us a set fee per transaction. This also varies depending on the type of card. Whether you pay a percentage or a pence rate, you may also accept other card brands and types, which may cost more. You'll be able to find the cards you accept in your transaction information.",
        id: 'mostcommonusedcard',
        refid: 'mostcommonusedcard-ref',
      },
      {
        description:
          'A card payment where the card, cardholder and merchant are all in the same place.',
        id: 'sameplace',
        refid: 'sameplace-ref',
      },
      {
        description:
          'A card payment where the card, cardholder and merchant are not all in the same place.',
        id: 'notsameplace',
        refid: 'notsameplace-ref',
      },
      {
        description:
          "A service for capturing and transferring payment data. You'll have a gateway quote if you selected over-the-phone or online payments. Gateway fees are subject to VAT and in addition to costs for accepting card payments through schemes such as VISA or Mastercard. Gateway fees may vary depending on your requirements.",
        id: 'capturingpaymentdata',
        refid: 'capturingpaymentdata-ref',
      },
      {
        description:
          'Charges relating to your compliance with card security and anti-fraud standards. The PCI DSS service fee is subject to VAT.',
        id: 'pcidssfee',
        refid: 'pcidssfee-ref',
      },
      {
        description:
          'Amount payable if your monthly transaction charges do not meet a minimum agreed amount.',
        id: 'notmeetminagreementamount',
        refid: 'notmeetminagreementamount-ref',
      },
      {
        description:
          'It can take 1-4 business days for funds to reach your account. This depends on your contract. Other options are available.',
        id: 'fundstoreachaccount',
        refid: 'fundstoreachaccount-ref',
      },
    ],
    journeyHeader: {
      header: 'Our card payments service',
      serviceName: 'Online quotation tool',
      stepCounter:
        "This quote is based on the answers you've given and is only indicative.",
    },
    naFullForm: 'Not Applicable',
    notApplicable: 'N/A',
    otherSection: {
      monthlyCharges: {
        labels: {
          label1: 'Point-of-sale terminal (per terminal per month)',
          label2: 'Gateway',
          label2Ref: '8',
          label3: 'PCI DSS service fee',
          label3Ref: '9',
          label4: 'Minimum monthly service charge (MMSC)',
          label4Ref: '10',
        },
        labelText: 'Other monthly charges',
      },
      otherDetails: {
        labels: {
          label1: 'Settlement time',
          label1Ref: '11',
          label2: 'Payment brands accepted',
        },
        labelText: 'Other details',
      },
    },
    outputHeader: {
      headerText: {
        text1:
          'This summary shows our charges for card payments, and other important information about our service.',
        text2:
          'You can use this to compare our service with other providers, to find the best deal for you.',
        text3:
          'We are required to provide this information by the Payment Systems Regulator.',
      },
      logoAlt: 'Payment Systems Regulator Logo',
    },
    quoteReference: {
      label: 'Your quote reference:',
    },
    return: 'Return to Cardnet',
    returnSrText: 'Return to homepage',
    transactionCharges: {
      additionalCharges: {
        feeLabel: 'Authorisation fee',
        labelText: 'Additional charges per transaction',
      },
      cardPaymentsCharges: {
        cardsCategory: {
          category1: 'Debit',
          category1Ref: '2',
          category2: 'Credit',
          category2Ref: '3',
          category3: 'Business',
          category3Ref: '4',
          labelText: 'UK-based card',
        },
        cardTypes: {
          type1: 'Mastercard',
          type2: 'VISA',
        },
        labelText: 'Your costs for accepting common individual card payments',
        labelTextRef: '5',
        mode: {
          mode1: 'In person',
          mode1Ref: '6',
          mode2: 'Online/phone',
          mode2Ref: '7',
        },
      },
      otherCharges: {
        feeLabel1: 'Chargeback fee',
        feeLabel2: 'Retrieval fee',
        labelText: 'Other potential transaction charges',
      },
      spaceText: '**',
    },
  },

  customerDetails: {
    customerDetailsErrorHeading: 'Please try again later',
    customerDetailsErrorMessage:
      "There's been a techincal problem. If it persists, please call us for quote on <strong>0808 302 5118</strong>. Lines are open between 9am and 5pm, Monday to Friday.",
  },

  declineToQuote: {
    notification: {
      body: "Unfortunately, we can't offer you a quote at this time. This is because of the details you've given about the nature of your business.",
      heading: "We can't give you a quote",
    },
    returnToCardnet: 'Return to Cardnet',
    returnToCardnetSrText: 'Return to homepage',
  },
  footer: {
    accessibility: {
      link: 'https://www.lloydsbank.com/help-guidance/accessibility.html',
      text: 'Accessibility',
    },
    book: 'Book',
    cancel: 'Cancel',
    cancelSrText: 'The current session?',
    cardnet:
      'Cardnet® is a registered trademark of Lloyds Bank plc. We may monitor or record calls to make sure we have carried out your instructions correctly and to help improve the quality of our service. Please remember we cannot guarantee the security of messages sent by email. By using ',
    fcaLink: 'www.fca.org.uk',
    lgbLink: 'www.lloydsbankinggroup.com',
    next: 'Next',
    nextSrText: 'To see results',
    previous: 'Previous',
    sitemap: {
      link: 'https://www.lloydsbank.com/business/site-map.html',
      text: 'Sitemap',
    },
    submit: 'Submit',
    subText:
      'you agree to the outlined use of cookies in our cookie notice. Lloyds Bank plc and Bank of Scotland plc (member of Lloyds Banking Group) are authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority. Authorisation can be checked on the Financial Services Register at ',
  },
  footerContent: [
    {
      link: FOOTER.LEGALLink,
      text: FOOTER.LEGAL,
    },
    {
      link: FOOTER.PRIVACYLink,
      text: FOOTER.PRIVACY,
    },
    {
      link: FOOTER.SECURITYLink,
      text: FOOTER.SECURITY,
    },
    {
      link: FOOTER.COOKIESLink,
      text: FOOTER.COOKIES,
    },
    {
      link: FOOTER.CONTACTUSLink,
      text: FOOTER.CONTACTUS,
    },
  ],
  form: {
    fields: {
      dropDownUnselectedText: 'Select',
    },
    hasMoreThanOneFieldErrors: {
      text: 'Please check the highlighted fields below',
    },
  },
  header: {
    link: HEADER.LINK,
  },

  pdfTemplate: {
    callToActionAplication: {
      row1: {
        information: 'Lines are open between 9am and 5pm, Monday to Friday.',
        phone: '0800 161 5393',
        question: 'Already taking card payments with us?',
      },
      row2: {
        information: 'Lines are open between 9am and 5pm, Monday to Friday.',
        phone: '0330 134 7976',
        question: 'New to Lloyds Bank Cardnet?',
      },
      Title: ' Take card payments with Lloyds Bank Cardnet',
    },
    title: {
      customerMastercard: 'If your customer uses a Mastercard',
      customerVisa: 'If your customer uses a VISA',
      feeSubText: '(authorisation fee)',
      personalCredit: 'personal credit card online or by phone ',
      personalDebit: 'personal debit card in person',
      purchase: 'to purchase a £10 item, you would pay:',
    },
  },
  quotationForm: {
    components: {
      form: {
        averageCardPayment: {
          emptyErrorMessage: 'Please enter an amount',
          errorMessage: 'This must be no more than your card payments above',
          label: 'How much would an average card payment be?',
          supportiveText: '',
        },
        cardTurnOver: {
          emptyErrorMessage: 'Please enter an amount',
          errorMessage: 'Please enter a number to the nearest pound',
          label:
            'How much did you take in card payments in the last 12 months?',
          supportiveText:
            "If you're new to card payments, please give an estimate for the next 12 months.",
        },
        checkboxSupportiveText: {
          payOut: {
            bookAdded: 'Paying-in book added to application',
          },
        },
        faceToFacePercentageLabel: 'How much of this will be face to face?',
        minErrorMessage: (value) => `This should be at least £${value}`,
        paymentChannelLabel: 'How will you be taking payments?',
        paymentChannelOptions: [
          {
            id: '1',
            label: 'Face to face',
            name: 'payment-channel-face-to-face',
            taggingLabel: 'Face to Face Payments',
            value: 'FaceToFace',
          },
          {
            id: '2',
            label: 'Over the phone',
            name: 'payment-channel-over-the-phone',
            taggingLabel: 'Over the Phone Payments',
            value: 'OverThePhone',
          },
          {
            id: '3',
            label: 'Online',
            name: 'payment-channel-online',
            taggingLabel: 'Online Payments',
            value: 'Online',
          },
        ],
        validation: {
          averageCardPayment: {
            min: 1,
          },
          cardTurnOver: {
            max: 999999999,
            maxAmount: 50000000,
            min: 1,
          },
          faceToFacePercentage: {
            requiredField: 'Please enter a number between 1 and 99',
          },
          paymentChannel: {
            requiredField: 'Please select all that apply',
          },
        },
      },
      industry: {
        errorMessage: 'Please select an option',
        label: 'Your industry',
      },
      journeyHeader: {
        header: 'Tell us about your business',
        serviceName: 'Online quotation tool',
        stepCounter:
          'Your answers will help us create an example quote for you.',
      },
      pciDss: {
        errorMessage: 'Please select an option',
        label: 'How will you manage PCI DSS compliance?',
        model: {
          desc1:
            'The Payment Card Industry Data Security Standard (PCI DSS) is a set of card security and anti-fraud standards.',
          desc2:
            'Each payment you take will involve sensitive cardholder data. This data must be handled securely to protect your customers and business from fraud. You have to comply with the PCI DSS if you want to take card payments.',
          label: "What's PCI DSS?",
          title: "What's PCI DSS?",
        },
        radioBtnlabel: [
          {
            label: 'I’ll be managing it myself.',
            value: 'manage-myself',
          },
          {
            label: 'I’d like help with my reporting.',
            value: 'help-needed',
          },
        ],
      },
      sector: {
        errorMessage: 'Please select an option',
        errorMessageEmptyIndustry: 'Please select your industry first',
        label: 'Your sector',
        mccLabel: "What's an MCC?",
        supportiveLabel:
          "You'll find a merchant category code (MCC) in brackets next to each sector.",
        tooltipDesc1:
          "A merchant category code (MCC) tells us what kind of goods or services you offer. This helps us find out if we're able to offer you a quote.",
        tooltipDesc2: 'You may also need your MCC to compare quotes.',
        tooltipTitle: "What's an MCC?",
      },
      warning: {
        already: 'Already a customer?',
        bankList1: 'Lloyds Bank Cardnet',
        bankList2: 'Lloyds Bank',
        bankList3: 'Bank of Scotland',
        callingDay: 'Lines are open between 9am and 5pm, Monday to Friday.',
        callUsLabel: 'Please call us on',
        cancelDialog: 'Cancel Dialog',
        contactNumber: '0330 134 7976',
        getInTouch:
          "Please get in touch with your contact if you're a customer of:",
        heading: "Let's discuss your business needs",
        notCustomer: 'Not a customer currently?',
        ok: 'OK',
        okSrText: 'To close pop up',
        title:
          'Given your high annual card turnover, please call us for a tailored quote.',
      },
    },
  },
  systemFailure: {
    notification: {
      body: "There's been a technical problem.",
      heading: 'Please try again later',
    },
    returnToCardnet: 'Return to Cardnet',
    returnToCardnetSrText: 'Return to homepage',
  },
  thankYouCallbackPage: {
    heading: 'Thank you',
    returnAccountCta: 'Return to account',
    subHeading: "We'll call you within the next two business days.",
  },
  warning: {
    edit: 'No, edit',
  },
};
